__turbopack_context__.v({
  "buttonInteractionWrapper": "styles-module__aLJTpG__buttonInteractionWrapper",
  "container": "styles-module__aLJTpG__container",
  "interactionButton": "styles-module__aLJTpG__interactionButton",
});
